import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';

import { HashLink } from 'react-router-hash-link';

import { Container, Wrapper, NavMenu } from './styles';

const style = { borderBottom: '4px solid #5e17eb' };

export default class Menu extends Component {
  render() {
    return (
      <Container>
        <Wrapper>
          <NavMenu>
            <li>
              <NavLink exact to="/" activeStyle={style}>HOME</NavLink>
            </li>
            <li>
              <NavLink to="/about" activeStyle={style}>ABOUT ME</NavLink>
            </li>
            <li>
              <NavLink to="/skills" activeStyle={style}>SKILLS</NavLink>
            </li>
            <li>
              <NavLink to="/projects" activeStyle={style}>PROJECTS</NavLink>
            </li>
            <li>
              <HashLink to="/#contact">CONTACT</HashLink>
            </li>
          </NavMenu>
        </Wrapper>
      </Container>
    );
  }
}
